import type { ReactElement } from 'react';
import { BillingDataPlatform } from 'reactApp/api/billing/data/BillingDataAPICall.types';
import type { Partner } from 'reactApp/modules/billingData/billing.data';
import type { BaseSubscriptionType, BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import type { IPromoQuotaSubscription } from 'reactApp/modules/promoTariffs/promoTariffs.types';
import type { Product } from 'reactApp/types/Billing';

export type TSubscriptionItem = BillingDataSubscriptionInfo | BaseSubscriptionType | IPromoQuotaSubscription;

export interface IProps {
    subscription: BillingDataSubscriptionInfo | BaseSubscriptionType;
    onClick: (subscriptionId: string) => void;
}

export interface IContent {
    header: ReactElement;
    warning: string;
}

export interface ISubscriptionModalContent {
    subscription: TSubscriptionItem;
    product: Product | undefined;
    partner?: Partner;
}

export const SubscriptionMobileName: Partial<Record<BillingDataPlatform, string>> = {
    [BillingDataPlatform.ios]: 'AppStore',
    [BillingDataPlatform.android]: 'Google Play',
    [BillingDataPlatform.rustore]: 'RuStore',
};
